import { render, staticRenderFns } from "./TopBtn.vue?vue&type=template&id=fbb6dca0&scoped=true&lang=html&"
import script from "./TopBtn.vue?vue&type=script&lang=js&"
export * from "./TopBtn.vue?vue&type=script&lang=js&"
import style0 from "./TopBtn.vue?vue&type=style&index=0&id=fbb6dca0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb6dca0",
  null
  
)

export default component.exports